import React, { useEffect, useState } from 'react';
import { string, object } from 'prop-types';
import classNames from 'classnames';
import { FormattedMessage } from '../../../util/reactIntl';

import { NamedLink } from '../../../components';

import css from './SectionInfo.module.css';
import whySellImage from '../../../assets/images/why-sell.png';
import whyBuyImage from '../../../assets/images/why-buy.png';
import background from '../../../assets/images/infoBg.png';

const SectionInfo = props => {
  const { className, rootClassName } = props;

  const classes = classNames(rootClassName || css.root, className, css.sectionInfo);

  return (
    <section className={classes} style={{ backgroundImage: `url(${background})` }}>
      <div className={css.container}>
        <div>
          <div>
            <div className={css.cardTitle}>Why Sell with Bowtackle?</div>
            <div className={css.cardContent}>Join the Bowtackle online ecosystem and spend less of your time managing software and more time serving customers and boosting sales.<br/><br/>This site was designed and built by outdoor-industry experts to eliminate operational headaches.</div>
            <div className={css.buttonContainer}>
              <NamedLink className={css.secondaryLink} name="SignupForUserTypePage" params={{ userType: 'provider' }}>Apply to Sell</NamedLink>
              <NamedLink className={css.primaryLink} name="BecomeASellerPage">Learn More</NamedLink>
            </div>
          </div>
          <div className={css.cardImage}>
            <img src={whySellImage} alt="Why Sell with Bowtackle"/>
          </div>
        </div>
        <div>
          <div className={css.cardImage}>
            <img src={whyBuyImage} alt="Why Buy with Bowtackle"/>
          </div>
          <div>
            <div className={css.cardTitle}>Why Buy with Bowtackle?</div>
            <div className={css.cardContent}>Sellers on Bowtackle have been vetted and selected for their quality and professionalism.<br/><br/>As a customer you’ll experience the convenience of online shopping, but still enjoy the customer service & knowledge of a Pro Shop.</div>
            <div className={css.buttonContainer}>
              <NamedLink className={css.primaryLink} name="SignupPage">Create Buyer Account</NamedLink>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SectionInfo;
